module.exports = __webpack_public_path__ + "img/websiteDisplay.8fb722ea.webp";